// Official LHS mark — exact crop of the provided brand asset (public/lhs-mark.png, 489x405)
const MARK_RATIO = 489 / 405;

export default function Logo({ size = 40, className = "", style = {} }) {
  const h = size;
  const w = Math.ceil(size * MARK_RATIO);
  return (
    <div className={`inline-flex items-center flex-shrink-0 ${className}`} style={{ paddingRight: Math.max(4, Math.round(size * 0.1)), overflow: "visible", ...style }}>
      <img
        src="/lhs-mark.png"
        alt="LHS"
        width={w}
        height={h}
        draggable={false}
        data-testid="lhs-logo-mark"
        style={{ width: w, height: h, minWidth: w, objectFit: "contain", display: "block", overflow: "visible" }}
      />
    </div>
  );
}

export function BrandLockup({ size = 40, tagline = true }) {
  return (
    <div className="flex items-center gap-3">
      <Logo size={size} />
      <div className="leading-tight">
        <div className="font-display font-extrabold text-[#0A2A5E] text-lg tracking-tight">LUMIS HR</div>
        {tagline && <div className="text-[10px] uppercase tracking-[0.2em] text-[#C7761A] font-semibold">Empowering people · Simplifying HR</div>}
      </div>
    </div>
  );
}
